import i18nIsoCountries from "i18n-iso-countries";
import de from "i18n-iso-countries/langs/de.json";
import da from "i18n-iso-countries/langs/da.json";
import el from "i18n-iso-countries/langs/el.json";
import en from "i18n-iso-countries/langs/en.json";
import es from "i18n-iso-countries/langs/es.json";
import fi from "i18n-iso-countries/langs/fi.json";
import fr from "i18n-iso-countries/langs/fr.json";
import it from "i18n-iso-countries/langs/it.json";
import ko from "i18n-iso-countries/langs/ko.json";
import nb from "i18n-iso-countries/langs/nb.json";
import nl from "i18n-iso-countries/langs/nl.json";
import pl from "i18n-iso-countries/langs/pl.json";
import sv from "i18n-iso-countries/langs/sv.json";
import tr from "i18n-iso-countries/langs/tr.json";

i18nIsoCountries.registerLocale(de);
i18nIsoCountries.registerLocale(da);
i18nIsoCountries.registerLocale(el);
i18nIsoCountries.registerLocale(en);
i18nIsoCountries.registerLocale(es);
i18nIsoCountries.registerLocale(fi);
i18nIsoCountries.registerLocale(fr);
i18nIsoCountries.registerLocale(it);
i18nIsoCountries.registerLocale(ko);
i18nIsoCountries.registerLocale(nb);
i18nIsoCountries.registerLocale(nl);
i18nIsoCountries.registerLocale(pl);
i18nIsoCountries.registerLocale(sv);
i18nIsoCountries.registerLocale(tr);

export default function useCountryValues() {
  return {
    countries: i18nIsoCountries,
  };
}
